import { TOKEN_TERM } from '../../../constants';
import { Token } from '../../../Values/Token';

/**
 * Word term token.
 *
 */
export class Word extends Token {
  constructor(
    lexeme: string,
    position: number,
    public domain: string,
    public word: string,
  ) {
    super(TOKEN_TERM, lexeme, position);
  }
}
